import { createApp } from 'vue';
import { createPinia } from 'pinia';
import 'element-plus/es/components/message/style/css';
import 'element-plus/es/components/message-box/style/css';
import 'element-plus/es/components/loading/style/css';
import 'element-plus/theme-chalk/dark/css-vars.css';
import './styles/base.css';
import './styles/mobile-responsive.css';
import './styles/mobile-dark.css';
import './styles/desktop-dark.css';
import App from './App.vue';
import router from './router';
import { useUserStore } from './store/user';
import { preloadTheme } from './store/page-settings';

async function bootstrap() {
  // Apply persisted theme (light / dark / follow system) before mount to avoid a flash.
  preloadTheme();

  const app = createApp(App);
  const pinia = createPinia();

  app.use(pinia);
  app.use(router);

  const userStore = useUserStore();
  const isMobileBrowser = window.innerWidth < 768;

  if (userStore.accessToken) {
    // 检查 token 是否已过期（本地解码检查 exp 声明）
    if (userStore.isTokenExpired()) {
      // 尝试用 refresh token 刷新
      const refreshed = await userStore.refreshAccessToken();
      if (!refreshed) {
        // 刷新失败，清除 token 并跳转登录页
        userStore.logout({ expired: '1' }, isMobileBrowser ? '/m/login' : '/login');
        app.mount('#app');
        return;
      }
    }
    // Token 有效，挂载 App 并在后台拉取用户信息
    app.mount('#app');
    userStore.fetchProfile().catch(() => {});
    userStore.fetchPermissions().catch(() => {});
  } else {
    app.mount('#app');
  }
}

bootstrap();
